<template>
    <Modal2 v-if="visible" :showFooter="false" :showTitle="false" design="v3" @cancel="$emit('close')">
        <div class="plan-limit-warning">
            <div class="plan-limit-warning-icon" :class="iconColorClass">
                <svg v-if="isUsageType" viewBox="0 0 24 24" width="48" height="48" fill="none"
                    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
                    <line x1="12" y1="9" x2="12" y2="13" />
                    <line x1="12" y1="17" x2="12.01" y2="17" />
                </svg>
                <svg v-else viewBox="0 0 24 24" width="48" height="48" fill="none"
                    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="12" cy="12" r="10" />
                    <line x1="12" y1="8" x2="12" y2="12" />
                    <line x1="12" y1="16" x2="12.01" y2="16" />
                </svg>
            </div>

            <h3 class="plan-limit-warning-title">{{ title }}</h3>
            <p class="plan-limit-warning-message">{{ message }}</p>

            <div class="plan-limit-warning-actions">
                <SupsisButton primary @click="$emit('close')">Tamam</SupsisButton>
            </div>
        </div>
    </Modal2>
</template>

<script>
import Modal2 from '../common/Modal2.vue';
import SupsisButton from '../../views/Pages/Settings/components/SupsisButton.vue';

var USAGE_TYPES = ['chatbot', 'automation', 'web', 'mail'];

var TITLES = {
    supsis: 'Temsilci Limit Uyarısı',
    whatsapp: 'WhatsApp Kanal Limit Uyarısı',
    'whatsapp-business': 'WhatsApp Business Kanal Limit Uyarısı',
    instagram: 'Instagram Kanal Limit Uyarısı',
    messenger: 'Messenger Kanal Limit Uyarısı',
    trendyol: 'Trendyol Kanal Limit Uyarısı',
    'meta-lead': 'Meta Lead Kanal Limit Uyarısı',
    telegram: 'Telegram Kanal Limit Uyarısı',
    linkedin: 'LinkedIn Kanal Limit Uyarısı',
    webphone: 'Webphone Kanal Limit Uyarısı',
    chatbot: 'Chatbot Limit Uyarısı',
    automation: 'Otomasyon Limit Uyarısı',
    web: 'Web Ziyaret Limit Uyarısı',
    mail: 'E-posta Limit Uyarısı',
};

var MESSAGES = {
    supsis: 'Aktif temsilci sayınız bu planın sunduğu limiti aşmaktadır. Lütfen temsilcilerinizi deaktif edin veya silin.',
    whatsapp: 'Kullandığınız WhatsApp kanal sayısı bu planın sunduğu limiti aşmaktadır. Lütfen kanal sayınızı azaltın.',
    'whatsapp-business': 'Kullandığınız WhatsApp Business kanal sayısı bu planın sunduğu limiti aşmaktadır. Lütfen kanal sayınızı azaltın.',
    instagram: 'Kullandığınız Instagram kanal sayısı bu planın sunduğu limiti aşmaktadır. Lütfen kanal sayınızı azaltın.',
    messenger: 'Kullandığınız Messenger kanal sayısı bu planın sunduğu limiti aşmaktadır. Lütfen kanal sayınızı azaltın.',
    trendyol: 'Kullandığınız Trendyol kanal sayısı bu planın sunduğu limiti aşmaktadır. Lütfen kanal sayınızı azaltın.',
    'meta-lead': 'Kullandığınız Meta Lead kanal sayısı bu planın sunduğu limiti aşmaktadır. Lütfen kanal sayınızı azaltın.',
    telegram: 'Kullandığınız Telegram kanal sayısı bu planın sunduğu limiti aşmaktadır. Lütfen kanal sayınızı azaltın.',
    linkedin: 'Kullandığınız LinkedIn kanal sayısı bu planın sunduğu limiti aşmaktadır. Lütfen kanal sayınızı azaltın.',
    webphone: 'Kullandığınız Webphone kanal sayısı bu planın sunduğu limiti aşmaktadır. Lütfen kanal sayınızı azaltın.',
    chatbot: 'Mevcut kullanımınızdaki chatbot oturum sayısı bu planın sunduğu limiti aşmaktadır.',
    automation: 'Mevcut kullanımınızdaki otomasyon görev sayısı bu planın sunduğu limiti aşmaktadır.',
    web: 'Mevcut kullanımınızdaki web ziyaret sayısı bu planın sunduğu limiti aşmaktadır.',
    mail: 'Mevcut kullanımınızdaki e-posta gönderim sayısı bu planın sunduğu limiti aşmaktadır.',
};

export default {
    name: 'PlanLimitWarningModal',
    components: {
        Modal2,
        SupsisButton,
    },
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        planType: {
            type: String,
            default: '',
        },
        isCancel: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        isUsageType: function () {
            return USAGE_TYPES.indexOf(this.planType) !== -1;
        },
        iconColorClass: function () {
            return this.isUsageType ? 'warning' : 'info';
        },
        title: function () {
            return TITLES[this.planType] || 'Limit Uyarısı';
        },
        message: function () {
            var prefix = this.isCancel
                ? 'Bu planı iptal edebilmek için '
                : 'Bu plana geçiş yapılamaz. ';
            var msg = MESSAGES[this.planType];
            if (!msg) return prefix + 'Mevcut kullanımınız bu planın sunduğu limiti aşmaktadır.';
            return prefix + msg;
        },
    },
};
</script>

<style lang="scss" scoped>
.plan-limit-warning {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 32px 24px;
    gap: 16px;

    &-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 80px;
        height: 80px;
        border-radius: 50%;

        &.warning {
            background: #fff7e6;
            color: #fa8c16;
        }

        &.info {
            background: #fff1f0;
            color: #f5222d;
        }
    }

    &-title {
        font-size: 20px;
        font-weight: 600;
        color: #222;
        margin: 0;
    }

    &-message {
        font-size: 14px;
        line-height: 22px;
        color: #555;
        margin: 0;
        max-width: 380px;
    }

    &-actions {
        margin-top: 8px;
        width: 100%;
        display: flex;
        justify-content: center;
    }
}
</style>
